export default {
  // serverURI: '/api'
  // serverURI: 'http://localhost:8181/api'
  serverURI: 'http://202.44.15.13:9080/gened/api'
}



// WEBPACK FOOTER //
// ./src/config/index.js